import { POST } from 'utils/requests.utils'

const BASE_URL = '/common/tracking_user_events'

export const track = (data) => POST(BASE_URL, data)
